import React from 'react';
import { SvgIcon, SxProps } from '@mui/material';

type Props = {
  sx?: SxProps;
};

export const LogoLarge = ({ sx = {} }: Props) => {
  return (
    <SvgIcon viewBox="0 0 57 19" sx={{ fill: 'none', ...sx }}>
      <path
        d="M35.1917 3.85136V13.4514H33.207V3.85136H35.1917ZM35.1917 0.622314V2.60703H33.207V0.622314H35.1917Z"
        fill="#071326"
      />
      <path
        d="M15.3031 3.85124V13.4513H13.3184V3.85124H15.3031ZM15.3031 0.622192V2.60691H13.3184V0.622192H15.3031Z"
        fill="#071326"
      />
      <path
        d="M23.871 4.16218C24.4683 4.47327 24.9349 4.93989 25.2709 5.55584C25.6069 6.17178 25.7749 6.91216 25.7749 7.78319V13.4449H23.8088V8.08183C23.8088 7.22324 23.5911 6.56375 23.1618 6.10334C22.7325 5.64294 22.1476 5.41274 21.401 5.41274C20.6544 5.41274 20.0696 5.64294 19.6341 6.10334C19.1986 6.56375 18.9808 7.22324 18.9808 8.08183V13.4449H16.9961V3.8511H18.9808V4.94611C19.3043 4.55415 19.7212 4.24306 20.2251 4.0253C20.7291 3.80755 21.2704 3.69556 21.8366 3.69556C22.5894 3.69556 23.2675 3.8511 23.8648 4.1684L23.871 4.16218Z"
        fill="#071326"
      />
      <path
        d="M31.6046 5.46885H29.8252V13.445H27.8218V5.46885H26.6895V3.85121H27.8218V3.17305C27.8218 2.07182 28.1142 1.263 28.6991 0.759044C29.2839 0.255089 30.2047 0 31.4615 0V1.65496C30.858 1.65496 30.4349 1.76695 30.1923 1.99716C29.9496 2.22114 29.8252 2.6131 29.8252 3.17305V3.85121H31.6046V5.46885Z"
        fill="#071326"
      />
      <path
        d="M42.9656 4.13741C43.538 4.43605 43.9922 4.80312 44.3157 5.24486V3.85121H46.3191V13.6068C46.3191 14.4903 46.1325 15.2742 45.7592 15.9648C45.3859 16.6554 44.8508 17.1967 44.1477 17.5949C43.4447 17.9931 42.6048 18.1859 41.628 18.1859C40.3276 18.1859 39.2451 17.8811 38.3865 17.2714C37.5279 16.6616 37.0364 15.8341 36.9244 14.7889H38.8904C39.0397 15.2866 39.3633 15.691 39.8548 16.0021C40.3463 16.3132 40.9374 16.4625 41.6217 16.4625C42.4243 16.4625 43.0714 16.2199 43.5629 15.7284C44.0544 15.2431 44.3033 14.5338 44.3033 13.6006V11.9954C43.9673 12.4496 43.5131 12.8291 42.9345 13.1339C42.3621 13.4388 41.7088 13.5943 40.9747 13.5943C40.141 13.5943 39.3757 13.3828 38.6851 12.9597C37.9945 12.5367 37.447 11.9456 37.0488 11.1803C36.6506 10.4151 36.4453 9.55648 36.4453 8.59212C36.4453 7.62776 36.6444 6.77539 37.0488 6.02879C37.447 5.28841 37.9945 4.7098 38.6851 4.29295C39.3757 3.88232 40.141 3.677 40.9747 3.677C41.7151 3.677 42.3746 3.82632 42.9532 4.11874L42.9656 4.13741ZM43.9051 6.91849C43.6313 6.4332 43.2767 6.0599 42.835 5.80481C42.3932 5.54972 41.9142 5.41907 41.404 5.41907C40.8938 5.41907 40.4147 5.5435 39.973 5.79237C39.5313 6.04124 39.1766 6.40832 38.9029 6.88738C38.6291 7.36645 38.4922 7.93885 38.4922 8.60457C38.4922 9.27028 38.6291 9.8489 38.9029 10.3466C39.1766 10.8444 39.5375 11.2239 39.9854 11.4852C40.4334 11.7465 40.9063 11.8772 41.404 11.8772C41.9017 11.8772 42.3932 11.7465 42.835 11.4914C43.2767 11.2363 43.6313 10.863 43.9051 10.3653C44.1788 9.87379 44.3157 9.29517 44.3157 8.62945C44.3157 7.96373 44.1788 7.39134 43.9051 6.90605V6.91849Z"
        fill="#071326"
      />
      <path
        d="M56.9946 3.85132L51.1089 17.9621H49.0557L51.0093 13.2958L47.2266 3.85132H49.4415L52.1417 11.168L54.9477 3.85132H57.0008H56.9946Z"
        fill="#071326"
      />
      <path
        d="M4.89184 0.679688H2.44531V3.12622H4.89184V0.679688Z"
        fill="#FF9B3D"
      />
      <path
        d="M2.44629 3.1261V11.0089H4.89551V3.1261H7.3418V13.4562H0V3.1261H2.44629Z"
        fill="#071326"
      />
    </SvgIcon>
  );
};
